<template>
  <div class="batch-update-class-date">
    <Modal
      v-model="show"
      width="700"
      title="编辑上课日期"
      :mask-closable="false"
      :closable="false"
      :footer-hide="true"
      :draggable="true"
    >
      <div class="main">
        <Form :label-width="180">
          <FormItem label="已选班级数："> {{ detailList.length }} 个</FormItem>
          <FormItem label="开课日期：">
            <DatePicker
              :value="classBeginDate"
              type="date"
              placeholder="选择开课日期"
              class="class-form-item-inline"
              :clearable="false"
              @on-change="handleGetBeginDate"
            ></DatePicker>
          </FormItem>
          <FormItem label="是否需要修改上课时间：">
            <RadioGroup v-model="actionType">
              <Radio :label="1">是</Radio>
              <Radio :label="2">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="actionType == 1" label="上课时间：">
            <TimePicker
              :value="classTime"
              class="time-block"
              format="HH:mm"
              type="timerange"
              placement="bottom-end"
              placeholder="请选择上课起止时间"
              :clearable="false"
              @on-change="handleGetBeginTime"
            ></TimePicker></FormItem>
        </Form>
        <Alert type="warning">
          <p>
            ①如果该上课日期已结算，则不允许调整上课时间
          </p>
          <p>
            ②如果调整至的月份已结算，则不允许调整
          </p>
          <p>
            ③如果该上课时间<span>存在</span>对应的学生请假单，则系统会<span>自动撤销该请假单</span>，请调整前仔细核对。
          </p>
        </Alert>
      </div>
      <div class="btn-box">
        <Button :disabled="classLoading" @click="handleCancel">取消</Button>
        <Button
          :loading="classLoading"
          type="primary"
          @click="handleCheckEditInfo"
        >确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import eduCenter from '@/request/eduCenter/index.js';
import educationAdminApi from '@/request/educationAdmin/index.js';
export default {
  props: {
    detailList: {
      type: Array,
      default: () => []
    },
    beginDate: {
      type: String,
      default: ''
    },
    beginTime: {
      type: Array,
      default: () => []
    },
    schoolId: {
      type: String,
      default: ''
    },
    yearCode: {
      type: Number || null,
      default: null
    },
    termCode: {
      type: String || null,
      default: ''
    }
  },
  data() {
    return {
      classLoading: false,
      show: false,
      cfmShow: false,
      classBeginDate: '',
      classTime: '',
      actionType: 1,
      cfmInfo: {
        failNum: '0',
        successNum: '0',
        failResult: [],
        successResult: []
      }
    };
  },
  watch: {
    beginDate(newVal) {
      this.classBeginDate = newVal;
    },
    beginTime(newVal) {
      this.classTime = newVal;
    }
  },
  methods: {
    // opt :{type: 1 单个、2 整列 }
    handleOpen(opt) {
      // this.actionType = opt ? opt['actionType'] : '';
      this.actionType = 2;
      this.show = true;
      this.classLoading = false;
    },
    handleGetBeginDate(date) {
      this.classBeginDate = date;
    },
    handleGetBeginTime(time) {
      this.classTime = time;
    },
    // 获取学校的aracode
    async getSchoolAreaCode(schoolId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          eduId: schoolId
        };
        const res = await educationAdminApi.getEduAreaName(params);
        if (res.status === 200) {
          resolve(res.message.areaCode);
        } else {
          reject(false);
        }
      });
    },
    // 在批量之前判断是否有请假的，有的二次弹窗
    async beforeUpdateNew() {
      return new Promise(async(resolve, reject) => {
        let hasLeave = 0;
        const detailIds = this.detailList.map(item => {
          return item.detailId;
        });
        const areaCode = await this.getSchoolAreaCode(this.schoolId);
        const params = {
          detailIds: detailIds.join(),
          pageNum: 1,
          pageSize: 1,
          schoolId: this.schoolId,
          areaCode,
          yearCode: this.yearCode,
          termCode: this.termCode
        };
        try {
          const res = await eduCenter.getLeaveStudentListApi(params);
          if (res.status === 200) {
            hasLeave = +res.message.total;
          }
          resolve(hasLeave);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      });
    },
    async handleCheckEditInfo() {
      // this.batchUpdateDetailDate();
      // return;
      // this.$Spin.show();
      this.classLoading = true;
      const tag = await this.beforeUpdateNew();
      this.classLoading = false;
      // this.$Spin.hide();
      // return;
      if (tag) {
        // console.log(this.beginDate, '是啥---');
        this.$Modal.confirm({
          title: '提示',
          content: `<p>原上课日期：${this.beginDate}  已存在学生的待审批请假单或已审批

                请假单信息，是否确认继续调整上课时间？</p>

                <p>确定后，系统将执行对应请假单的撤销操作，该操作不可恢复！

                请确认前仔细核对。</p>`,
          onOk: () => {
            this.batchUpdateDetailDate();
          }
        });
      } else {
        this.batchUpdateDetailDate();
      }
    },
    handleCancel() {
      this.show = false;
      this.$emit('on-cancel');
    },
    getParameter() {
      // .substring(11, 19)
      const updateDetailDateList = this.detailList.map(item => {
        return {
          detailId: item.detailId,
          classBeginDate: `${this.classBeginDate} 00:00:00`,
          classTimeBegin: this.actionType == 1 ? `${this.classBeginDate} ${this.classTime[0]}:00` : `${this.classBeginDate} ${item.classTimeBegin.substring(11, 19)}`,
          classTimeEnd: this.actionType == 1 ? `${this.classBeginDate} ${this.classTime[1]}:00` : `${this.classBeginDate} ${item.classTimeEnd.substring(11, 19)}`
        };
      });
      return {
        updateDetailDateList: updateDetailDateList
      };
    },
    async batchUpdateDetailDate() {
      // console.log('拿到的数据--', this.detailList);
      // return;
      const parameter = this.getParameter();

      this.classLoading = true;
      // this.$Spin.show();
      const res = await courseSchedulCenter.batchUpdateDetailDate(parameter);
      // this.$Spin.hide();
      this.classLoading = false;
      if (res.status == 200) {
        //  this.$Message.success('编辑成功');
        // this.cfmInfo = res.message;
        // this.cfmShow = true;
        this.show = false;
        this.$emit('on-finish', res.message);
      } else {

      }
    },
    handleCfm() {
      this.cfmShow = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.btn-box {
  display: flex;
  justify-content: flex-end;
  button + button {
    margin-left: 16px;
  }
}
p{
  line-height: 25px;
  span{
    color: red;
  }
}
</style>
